import React, { useState } from 'react';
import { Tippy } from '@superops/ui-design-system';
import ArticleAlert from '@nile/rmm/src/modules/knowledge-base/components/ArticleAlert';
import { SVGIcon } from '@superops/super-icons';
import {
  EventEmitter,
  useIsAuthorisedHook,
  getTranslatedText,
  toast,
  ALL_TABLES
} from '@nile/components';
import { KB_CONSTANTS } from '../../../constants/kb-constants';
import { useIntl } from 'react-intl';
import { AccountClient } from '@nile/graphql';
import { RESOLVE_ARTICLE_FEEDBACK } from '../../../graphql';
import { useKbContext } from '@nile/rmm/src/modules/knowledge-base';

const DeleteCell = (props) => {
  const { row, column } = props;
  const { bulkRecord, setbulkRecord } = useKbContext();
  const [openModal, setOpenModal] = useState(false);
  const { original: articleDetails } = row || {};
  const { feedbackId, itemType } = articleDetails || {};
  const isArticle = itemType === KB_CONSTANTS.KB_ARTICLE;
  const isFeedbackTable = column?.tableName === ALL_TABLES.kbFeedbackTable;
  const hasDeletePermission = useIsAuthorisedHook('knowledgeBase.delete');
  const isDeleteAuthorised = isFeedbackTable
    ? hasDeletePermission
    : hasDeletePermission && isArticle;

  const intl = useIntl();

  const handleToolbarAction = () => {
    setOpenModal((prevState) => !prevState);
  };

  const clearFeedback = () => {
    AccountClient.mutate({
      mutation: RESOLVE_ARTICLE_FEEDBACK,
      variables: {
        input: {
          feedbacks: [
            {
              feedbackId: feedbackId
            }
          ]
        }
      }
    })
      .then((res) => {
        if (res?.data?.resolveKbArticleFeedbacks) {
          toast('success', 'common.app.kb.article.feedback.clear');
          EventEmitter.dispatch(KB_CONSTANTS.KB_FB_LIST_TABLE_REFETCH_EVENT);
        }
      })
      .catch(() => {});
  };

  return (
    <div className="fx actr jctr">
      {isDeleteAuthorised && (
        <Tippy
          title={getTranslatedText(
            intl,
            isFeedbackTable ? 'common.clear' : 'common.delete'
          )}
        >
          <div
            className="edit-actions visibilityActions fx actr mr-20 cp"
            onClick={() => {
              if (isFeedbackTable) {
                clearFeedback();
              } else {
                handleToolbarAction();
              }
            }}
          >
            <SVGIcon name="Delete" color="red" />
          </div>
        </Tippy>
      )}
      {!isFeedbackTable && (
        <ArticleAlert
          actionName={'delete'}
          open={openModal}
          onClose={handleToolbarAction}
          article={articleDetails}
          postDeleteCallback={() => {
            handleToolbarAction();
            if (bulkRecord?.length > 0) {
              setbulkRecord([]);
            }
            EventEmitter.dispatch(KB_CONSTANTS.KB_LIST_TABLE_REFETCH_EVENT);
          }}
        />
      )}
    </div>
  );
};

export default DeleteCell;
